import $ from "jquery";
import qs from "qs";
import differenceInDays from "date-fns/differenceInDays";
import addDays from "date-fns/addDays";
import startOfDay from "date-fns/startOfDay";
import parse from "date-fns/parse";
import "./apartment.scss";

const allowedStartAts = [1, 8, 16, 24];

$("document").ready(function() {
  if ($(".shortcode-apartment").length) {
    startReservationForm();
  }
});

function startReservationForm() {
  const selectors = {
    shortcode: ".shortcode-apartment",
    videoToggle: ".shortcode-apartment .sp-video-toggle",
    goToReviews: ".shortcode-apartment .sp-goto-reviews",
    videoWrapper: "#video-wrapper",
    reviewsWrapper: "#reviews-wrapper",
    reservationForm:
      ".shortcode-apartment .sp-reservation-form-wrapper .sp-form",
    periodSelect:
      ".shortcode-apartment .sp-reservation-form-wrapper .sp-form .sp-period",
    startAtInput:
      ".shortcode-apartment .sp-reservation-form-wrapper .sp-form .sp-start-at",
    carouselWrapper: ".shortcode-apartment .sp-carousel-wrapper",
    sliderFor: ".sp-slides-wrapper .slider-for",
    sliderNav: ".sp-slides-wrapper .slider-nav",

    errorNotice: ".sp-error-notice"
  };

  const { apartment } = salaktaPlageConfig;
  const futureReservations = getFutureReservations(apartment);

  const periods = {
    1: 7,
    2: 14,
    3: 22,
    4: 30
  };

  let state = {
    period: null,
    startAt: null,
    forbiddenPeriods: []
  };

  startCarousel();
  registerEvents();
  loadValuesFromUrl();

  function startCarousel() {
    $(selectors.sliderFor).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: selectors.sliderNav
    });
    $(selectors.sliderNav).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: selectors.sliderFor,
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
    $(selectors.carouselWrapper).css("visibility", "visible");
  }

  function loadValuesFromUrl() {
    const { period } = qs.parse(location.search.substr(1));
    if (period) {
      $(selectors.startAtInput).datepicker("enable");
      setState(
        {
          period
        },
          (state) => prepareStartAt(state, true)
      );
      $(selectors.periodSelect).val(period);
    }
  }

  function registerEvents() {
    $(selectors.videoToggle).on("click", function() {
      try {
        $(selectors.videoWrapper)[0].scrollIntoView({ behavior: "smooth" });
      } catch (e) {
        console.log(selectors.videoWrapper, "not found");
      }
    });
    $(selectors.goToReviews).on("click", function() {
      try {
        $(selectors.reviewsWrapper)[0].scrollIntoView({ behavior: "smooth" });
      } catch (e) {
        console.log(selectors.reviewsWrapper, "not found");
      }
    });
    $(selectors.reservationForm).on("submit", function(e) {
      const valid = verifyFormData();
      if (!valid) {
        e.preventDefault();
        $(selectors.errorNotice).fadeIn();
      } else {
        $(selectors.errorNotice).fadeOut();
      }
    });
    $(selectors.periodSelect).on("change", function(e) {
      if ($(this).val()) {
        $(selectors.startAtInput).datepicker("enable");
      } else {
        $(selectors.startAtInput).datepicker("disable");
      }
      $(selectors.errorNotice).fadeOut();
      setState(
        {
          period: $(this).val(),
          startAt: null
        },
        prepareStartAt
      );
    });
    $(selectors.startAtInput).datepicker({
      dateFormat: "dd/mm/yy",
      gotoCurrent: true
    });

    $(selectors.startAtInput).on("keyup keydown", function(e) {
      e.preventDefault();
    });
    $(selectors.startAtInput).datepicker("disable");

    $(selectors.startAtInput).on("input change", function(e) {
      $(selectors.errorNotice).fadeOut();
      setState({
        startAt: $(this).val()
      });
    });
  }

  function verifyFormData() {
    return state.period && state.startAt;
  }

  function setState(newState, cb) {
    state = { ...state, ...newState };
    if (typeof cb === "function") {
      cb(state);
    }
  }

  function prepareStartAt(state, firstRun = false) {
    generateForbiddenPeriods(firstRun);
    updateAttachedDatepicker();
    updateAndFocusStartAt();
  }

  function dateInRange({ start_at, end_at, compareDate }) {
    const diffWithStartAt = differenceInDays(compareDate, start_at);
    const diffWithEndAt = differenceInDays(compareDate, end_at);

    if (diffWithStartAt >= 0 && diffWithEndAt < 0) {
      return true;
    }
    return false;
  }

  function dateAllowed({ start_at, end_at, compareDate }) {
    // 1. in between a forbidden date
    {
      const diffWithStartAt = differenceInDays(compareDate, start_at);
      const diffWithEndAt = differenceInDays(compareDate, end_at);

      if (diffWithStartAt >= 0 && diffWithEndAt < 0) {
        return false;
      }
    }
    // 2. period is too much
    {
      const selectedEntAt = addDays(compareDate, periods[state.period]);
      const diffWithStartAt = differenceInDays(selectedEntAt, start_at);
      const diffWithEndAt = differenceInDays(selectedEntAt, end_at);

      if (diffWithStartAt > 0 && diffWithEndAt <= 0) {
        return false;
      }
    }
    return true;
  }

  function updateAttachedDatepicker() {
    $(selectors.startAtInput).datepicker("option", "beforeShowDay", function(
      date
    ) {
      if (differenceInDays(date, new Date()) < 0)
        return [false, "sp-reservation-date-in-the-past"];

      {
        const futureReservations = getFutureReservations(apartment);

        let dateReserved = false;
        futureReservations.forEach(function({ start_at, end_at }) {
          // forbidden periods are in red
          // so short circuit
          if (dateInRange({ start_at, end_at, compareDate: date })) {
            dateReserved = true;
          }
        });
        if (dateReserved) {
          return [false, "sp-reservation-date-not-allowed"];
        }
      }

      if (allowedStartAts.indexOf(date.getDate()) === -1) {
        return [false, "sp-reservation-date-disabled"];
      }

      let enabled = true;
      let className = "sp-reservation-date-disabled";

      state.forbiddenPeriods.forEach(function({ start_at, end_at }) {
        if (enabled) {
          // start date so perform a normal check
          enabled = dateAllowed({
            start_at,
            end_at,
            compareDate: date
          });
        }
      });
      if (enabled) {
        className = "sp-reservation-date-in-range-start";
      }
      if (allowedStartAts.indexOf(date.getDate()) !== -1 && !enabled) {
        className = "sp-reservation-date-in-range-start-disabled";
      }

      return [enabled, className];
    });

    if (state.period) {
      $(selectors.startAtInput).prop("disabled", false);
    } else {
      $(selectors.startAtInput).prop("disabled", true);
    }
  }

  function generateForbiddenPeriods(firstRun = false) {
    const { start_at } = qs.parse(location.search.substr(1));
    let preferredStartAt;
    if (start_at) {
      preferredStartAt = parse(start_at, 'dd/MM/yyyy', new Date());
    }

    const { period } = state;
    const periodInDays = periods[period];
    const forbiddenPeriods = [];
    if (!period) {
      setState({
        forbiddenPeriods: [],
        startAt: null
      });
      return;
    }

    let cursor = new Date();
    futureReservations.forEach(function(reservation, index) {
      const { start_at, end_at } = reservation;

      const diff = differenceInDays(start_at, cursor);
      if (diff > 0 && diff < periodInDays) {
        forbiddenPeriods.push({ start_at: cursor, end_at: start_at });
      }

      // always push the current reservation
      forbiddenPeriods.push({ start_at, end_at });

      cursor = end_at;
    });

    setState({
      forbiddenPeriods
    });
    // will use state.forbiddenPeriods
    setState({
      startAt: firstRun && preferredStartAt ? preferredStartAt : getClosestStartAt()
    });
  }

  function getClosestStartAt() {
    const { forbiddenPeriods } = state;

    function getValidStartingAnchor(date) {
      const day = date.getDate();
      const month = date.getMonth();
      if (allowedStartAts.indexOf(day) !== -1) return date;

      if (day > 1 && day <= 8) {
        date.setDate(8);
      }
      if (day > 8 && day <= 16) {
        date.setDate(16);
      }
      if (day > 16 && day <= 24) {
        date.setDate(24);
      }
      if (day > 24) {
        date.setDate(1);
        date.setMonth(month + 1);
      }
      return date;
    }

    let anchor = startOfDay(getValidStartingAnchor(new Date()));

    let closestStartAt;
    forbiddenPeriods.forEach(function({ start_at, end_at }) {
      if (!closestStartAt) {
        const diffWithStartAt = differenceInDays(start_at, anchor);
        console.log({
          from: anchor.toString(),
          to: start_at.toString(),
          diff: diffWithStartAt,
          period: periods[state.period]
        });

        if (diffWithStartAt >= periods[state.period]) {
          closestStartAt = anchor;
        }
        anchor = end_at;
      }
    });

    if (!closestStartAt) closestStartAt = anchor;

    return getValidStartingAnchor(closestStartAt);
  }

  function updateAndFocusStartAt() {
    const { startAt } = state;
    if (startAt) {
      const year = startAt.getFullYear();
      let month = `${startAt.getMonth() + 1}`;
      if (month.length === 1) month = `0${month}`;
      let day = `${startAt.getDate()}`;
      if (day.length === 1) day = `0${day}`;
      const formatted = `${day}/${month}/${year}`;
      $(selectors.startAtInput)
        .val(formatted)
        .focus();
    } else {
      $(selectors.startAtInput).val("");
    }
  }
}

function getFutureReservations({ future_reservations }) {
  return future_reservations
    .map(function(item) {
      const { start_at, end_at } = item;
      const new_start_at = new Date(
        +start_at.slice(0, 4),
        +start_at.slice(4, 6) - 1,
        +start_at.slice(6)
      );
      const new_end_at = new Date(
        +end_at.slice(0, 4),
        +end_at.slice(4, 6) - 1,
        +end_at.slice(6)
      );

      return {
        ...item,
        start_at: new_start_at,
        end_at: new_end_at
      };
    })
    .sort(function compare(a, b) {
      return a.start_at - b.start_at;
    });
}
